import { Link } from 'react-router-dom';
import {motion} from 'motion/react';
import CDMorph from './landingAnimation.js'
import NavBar from './nav_bar.js';
import usePageSeo from './seo.js';
import SupportLine from './support_line.js';

const SITE_URL = 'https://mp3juug.com';
const PAGE_DESC =
  'MP3JUUG is a DIY music-distribution tool: upload your songs, generate one-time ' +
  'links, and put them on NFC cards (JUUGs) so fans tap to add your music ' +
  'to their library. 5 free links, then $5/month unlimited.';

const STRUCTURED_DATA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MP3JUUG',
    url: SITE_URL,
    description: 'DIY music distribution — artists distribute their own music on physical NFC media.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'MP3JUUG',
    url: SITE_URL,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is MP3JUUG?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'MP3JUUG is a DIY music-distribution tool. You upload your songs, generate one-time links, and put them on physical media like NFC cards (JUUGs). No label, no middleman.',
        },
      },
      {
        '@type': 'Question',
        name: 'How do fans get the music?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'A fan taps a JUUG (an NFC card) to their phone and the songs are added to their library. Each card’s link works once.',
        },
      },
      {
        '@type': 'Question',
        name: 'What does MP3JUUG cost?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The first 5 links are free, then it’s $5/month for unlimited links. Blank JUUG cards are sold separately in packs, from $5 for 5.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I keep my rights and revenue?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. You distribute directly to fans and keep your masters and your money — no per-stream payouts, no distributor cut.',
        },
      },
    ],
  },
];

/*
This will show 'MP3JUUG' in bolded letters
in the middle of the screen with a picture
of a CD morphing into an NFC card originally
with more mediums to be added to the animation
*/

function Landing(){
    usePageSeo({
      title: 'MP3JUUG — DIY: Distribute It Yourself',
      description: PAGE_DESC,
      jsonLd: STRUCTURED_DATA,
    });
    return (
      <>
        <NavBar />
        <main className='hero'>
          <div className='hero-content'>
            <div className='hero-text'>
              <span className='hero-eyebrow'>DIY Music Distribution</span>
              <motion.h1
                className='hero-title'
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              >
                From CD to JUUG.
              </motion.h1>
              <p className='hero-subtitle'>
                Upload your music, generate links, and put them onto
                physical media — no label, no middleman, no .0003 per stream.
              </p>
              <nav className='hero-actions' aria-label='Get started'>
                <Link to='/upload' className='btn btn-primary'>Try now</Link>
                <Link to='/link' className='btn btn-secondary'>Download</Link>
              </nav>
            </div>

            <div className='hero-visual' aria-hidden='true'>
              <CDMorph/>
            </div>
          </div>

          <div className='hero-features'>
            <div className='hero-feature'>
              <h2>Upload</h2>
              <p>Drop your tracks and cover art — we handle the storage.</p>
            </div>
            <div className='hero-feature'>
              <h2>Distribute</h2>
              <p>Generate links to apply on YOUR choice of physical media</p>
            </div>
            <div className='hero-feature'>
              <h2>Go physical</h2>
              <p>Place your links on any NFC physical object.</p>
            </div>
          </div>

          <section className='card faq hero-faq' aria-labelledby='home-faq'>
            <h2 id='home-faq'>Questions</h2>
            <details>
              <summary>What is MP3JUUG?</summary>
              <p>
                A DIY music-distribution tool. Upload your songs, generate one-time download
                links, and put them on physical media like NFC cards (JUUGs). No label, no
                middleman.
              </p>
            </details>
            <details>
              <summary>How do fans get the music?</summary>
              <p>
                A fan taps a JUUG to their phone and the songs are added to their library.
                Each card’s link works once.
              </p>
            </details>
            <details>
              <summary>What does it cost?</summary>
              <p>
                First 5 links free, then $5/month for unlimited. Blank JUUG cards
                are sold in packs, from $5 for 5.
              </p>
            </details>
            <details>
              <summary>Do I keep my rights and revenue?</summary>
              <p>
                Yes. You distribute straight to fans and keep your masters and your money —
                no per-stream payouts, no distributor cut.
              </p>
            </details>
          </section>

          <SupportLine />
        </main>
      </>
    );

}

export default Landing;
